import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Skeleton,
  Typography,
} from '@mui/material';
import React from 'react';
import Assessment from '../assessment/Assessment';
import ksimSelfstudyCloud from '../assets/ksim-self-study-cloud.png';
import { SquareChip } from '../chip/TypeChip';
import Fallback from '../fallback/Fallback';
import { AssessmentScore, Assessment as IAssessment, SimulationStatus } from '../types';

export interface AssessmentsProps {
  assessments?: IAssessment[];
  error?: any;
  loading?: boolean;
  simulationStatus: SimulationStatus;
}

const Assessments = ({ assessments, loading, error, simulationStatus }: AssessmentsProps) => (
  <>
    <Typography variant="h5" mb={4}>
      Assessment
    </Typography>

    {loading ? (
      <Skeleton height={382} variant="rounded" sx={{ mb: 4 }} />
    ) : (
      <>
        {!assessments?.length ? (
          <Card sx={{ mb: 4 }}>
            <CardContent>
              <Fallback
                imgSrc={ksimSelfstudyCloud}
                message={error ? 'There is no assessment available' : 'The assessment will be displayed here'}
              />
            </CardContent>
          </Card>
        ) : assessments?.length === 1 ? (
          <Assessment assessment={assessments[0]} simulationStatus={simulationStatus} />
        ) : (
          <Card sx={{ mb: 4 }}>
            {assessments?.map((assessment, index) => (
              <Accordion key={index}>
                <AccordionSummary expandIcon={<ExpandMore />} sx={{ gap: 2 }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" flex={1}>
                    <Typography component="h2" variant="subtitle1">
                      {assessment.name}
                    </Typography>
                    <SquareChip
                      label={
                        <Box display="flex" alignItems="center">
                          {assessment.scorePercent}% {assessment.passed ? 'Passed' : 'Failed'}
                        </Box>
                      }
                      size="small"
                      type={assessment.passed ? AssessmentScore.Positive : AssessmentScore.Negative}
                    />
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Assessment assessment={assessment} simulationStatus={simulationStatus} />
                </AccordionDetails>
              </Accordion>
            ))}
          </Card>
        )}
      </>
    )}
  </>
);

export default Assessments;
